import * as Sentry from '@sentry/vue';

export const initSentryUser = id => {
    Sentry.setUser({ id });
};
